<template>
    <div class="wraper">
        <div v-loading="loading">

            <div v-if="courses == null" id="no-courses">
                <h1 id="study-plan-title">No hay Cursos</h1>
            </div>

            <div v-else>
                <div v-for="course in courses">
                    <view-allcourses :courseId="course"></view-allcourses>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import viewAllcourses from '@/components/courses/myCourses/viewAllcourses'
import { getTrainingByPosition } from '@/requests/trainings'
import axios from 'axios'
import { userAPIRoot } from '@/config/users.config'
export default {
    components: { viewAllcourses },
    data(){
        return { 
            loading: false,
            courses: null,
        }
    },
    mounted() {
        this.loading = true
        axios.get(userAPIRoot+'/users/'+this.$session.get('userId')+'/companyUsers')
        .then((respuesta)=>{
            //console.log(respuesta.data)
            if(respuesta.data[0]){
                getTrainingByPosition({ companyId: respuesta.data[0].company, positionId: respuesta.data[0].position})
                .then((res)=>{
                    if(res.items[0]){
                        // console.log(res)
                        console.log(res.items[0])
                        this.courses = res.items[0].courses
                        this.loading = false
                    }
                })
            }
        })
        this.loading = false
    }
    
}
</script>

<style>
    #study-plan-title {
        margin: 0px 0px 10px;
        color: #0056A8;
    }

    #no-courses {
        margin: 0 auto;
        padding: 100px;
        position: static;
    }
</style>



// WEBPACK FOOTER //
// src/components/courses/myCourses/allCourses.vue